import { render } from "./Footer.vue?vue&type=template&id=52e068e6"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=52e068e6&lang=scss"

import exportComponent from "/Users/molinam/gitlab/techbio2025-vue-app/vue-mobile-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__